
import ReactModal from "react-modal";
import cn from "classnames";

import { Typography } from "../Typography";

import styles from "./ModalSheet.module.scss";

import { ModalSheetProps } from "./ModalSheet.types";

const ModalSheet = ({
  className,
  portalClassName,
  open = false,
  centered = true,
  isDragging,
  title,
  translateY,
  closeTimeoutMS = 300,
  position,
  children,
  onClose,
  onAfterOpen,
  onAfterClose,
  onDragStart,
}: ModalSheetProps) => (
  <>
    {/* @ts-ignore */}
    <ReactModal
      portalClassName={cn(styles.portal, portalClassName)}
      overlayClassName={cn(styles.overlay, {
        [styles.overlayCentered]: centered,
        [styles.overlayNoScroll]: isDragging, // Новый класс для отключения скролла
      })}
      className={cn(styles.modal, className, position && styles[position])}
      style={{
        content: {
          transform: `translateY(${translateY})`,
          transition: isDragging ? "none" : "transform 0.3s",
        },
      }}
      isOpen={open}
      closeTimeoutMS={closeTimeoutMS}
      onRequestClose={onClose}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      bodyOpenClassName={null}
    >
      <div
        className={cn(styles.dragHandle, { [styles.dragHandleDragging]: isDragging })}
        onMouseDown={onDragStart}
        onTouchStart={onDragStart}
      />
      <div className={styles.content}>
        {title && (
          <Typography className={styles.sortWrapperTitle} variant="h3">
            {title}
          </Typography>
        )}
        {children}
      </div>
    </ReactModal>
  </>
);


export default ModalSheet;